import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import {MenuPage} from '../menu/menu.page';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import {HomePage} from '../home/home.page';
import {MatSnackBar} from '@angular/material/snack-bar';
import Map = google.maps.Map;
import Marker = google.maps.Marker;
import LatLng = google.maps.LatLng;
import {MapsUtils} from '../../../smoothr-web-app-core/utils/maps-utils';
import {environment} from '../../../environments/environment';
import {AngularFireAnalytics} from '@angular/fire/compat/analytics';
import {getLatLng, sleep} from 'src/smoothr-web-app-core/utils/utils';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import {Api} from '../../../smoothr-web-app-core/api/api';
import {TranslateService} from '@ngx-translate/core';
import {SelectTableListComponent} from 'src/app/components/select-table-list/select-table-list.component';
import {ModalController} from '@ionic/angular';
import Order from 'src/smoothr-web-app-core/models/Order';
import RepositoryDirective from 'src/smoothr-web-app-core/directives/repository-directive';

@Component({
	selector: 'app-venue',
	templateUrl: './venue.page.html',
	styleUrls: ['venue.page.scss']
})
export class VenuePage extends RepositoryDirective implements OnInit {
	static url = 'scan-qr/:venueId';
	private static venues: Venue[] = [];
	private static preorderType: PreorderType = null;

	@ViewChild('mapContainer', {static: false})
	gmap: ElementRef;
	map: Map;
	order: Order;
	loading = true;
	venues: Venue[];
	preorderType: PreorderType;
	showMap = true;
	clusterer: MarkerClusterer = null;
	mapOptions: google.maps.MapOptions = {
		zoom: 18,
		maxZoom: 18,
		disableDefaultUI: true,
		clickableIcons: false,
		styles: [
			{
				featureType: 'poi.business',
				stylers: [{visibility: 'off'}]
			}
		]
	};
	selectedVenue: Venue = null;

	constructor(
		private router: Router,
		protected repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private analytics: AngularFireAnalytics,
		private route: ActivatedRoute,
		private translate: TranslateService,
		private modalCtrl: ModalController
	) {
		super(repository);
		this.route.params.subscribe(params => {
			if (params?.venueId) {
				console.log(params.venueId);
				this.setupPage(params?.venueId);
			}
		});
	}

	static navigate(router: Router, venues: Venue[], preorderType: PreorderType) {
		VenuePage.venues = venues;
		VenuePage.preorderType = preorderType;
		router.navigateByUrl(VenuePage.url);
	}
	async setupPage(venueId: string) {
		this.loading = false;
		const venue = await this.repository.getVenue(venueId);

		if (venue) {
			this.map = new Map(this.gmap.nativeElement, this.mapOptions);
			const latLng = getLatLng(venue);
			this.map.setCenter(
				new LatLng(latLng.latitude - 0.00025, latLng.longitude)
			);
			this.setupMap(venue, [venue]);
			await this.openSelectTable(venue);
		} else {
			this.snackbarCtrl.open(
				this.translate.instant('venue_page.venue_not_found'),
				null,
				{
					duration: 4000
				}
			);
		}
	}
	async openSelectTable(venue: Venue) {
		this.repository.createOrder(venue, null, PreorderType.INSIDE);
		await sleep(150);
		console.log(this.order);
		const selectedTable = await SelectTableListComponent.show(
			this.modalCtrl,
			venue,
			this.order
		);
		if (selectedTable) {
			this.order.tableNumber = selectedTable.number;
			this.order.table = selectedTable._id;
			this.repository.order.emit(this.order);
			await sleep(200);
			MenuPage.navigate(this.router);
		}
	}

	ngOnInit() {
		super.ngOnInit();
	}

	setupMap(selectedVenue: Venue, venues: Venue[]) {
		this.selectedVenue = selectedVenue;
		this.clusterer = MapsUtils.addVenuesToMap(
			this.clusterer,
			selectedVenue,
			venues,
			this.map,
			venue => this.setupMap(venue, venues)
		);
	}

	async selectVenue(
		venue: Venue,
		preorderType: PreorderType,
		attempt: number = 0,
		prevError: any = null
	) {
		if (attempt > 5) {
			this.loading = false;
			console.error(prevError);
			this.snackbarCtrl.open(prevError, null, {
				duration: 2000
			});
			return;
		}
		this.loading = true;
		try {
			await this.repository.getVenue(venue._id);
			this.repository.createOrder(venue, null, preorderType, null);
			await this.analytics.logEvent('venue_selected', {
				name: venue.name,
				readableId: venue.readableId,
				preorderType
			});
			await MenuPage.navigate(this.router);
			this.loading = false;
		} catch (e) {
			await this.selectVenue(venue, preorderType, attempt + 1, e);
		}
	}
}
